import React, { useEffect, useState, useRef } from "react";

import cssClasses from "./ViewLaunches.module.css";
import { useNavigate } from "react-router-dom";
import backArrow from "../../../Assets/Images/backArrow.svg";
import { Card } from "@mui/material";
import {useDispatch, useSelector } from "react-redux";
import actions from "../../../Redux Store/actions";
import EventDefaultImg from "../../../Assets/Images/LaunchDefaultImage.png";
import LeadStatusChip from "../../../Subcomponents/LeadStatusChip";
import Calendar from "../../../Assets/Images/calendar.svg";
import Dot from "../../Icons/Dot";
import PlaceIcon from "@mui/icons-material/Place";
import ViewMore from "../../../Assets/Images/viewMoreIcon.svg";
export default function ViewLaunches() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let launch = JSON.parse(localStorage.getItem("launch"));
  useEffect(() => {
    dispatch(actions.activeMenu("home"));
  }, [])
  
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.wrapperHeader}>
        <div className={cssClasses.headerTitle}>
          <img
            src={backArrow}
            alt=""
            onClick={() => {
              navigate("/Home/Dashboard");
            }}
            style={{ cursor: "pointer", marginRight: "1rem" }}
          />
          <span>{launch.launch[0].eventtitle}</span>
        </div>
        {/* <div className={cssClasses.headerSubTitle}>{project.addressLine2}</div> */}
      </div>
      <div className={cssClasses.wrapperContent}>
        <div className={cssClasses.eventsWrapper}>
          {launch.launch.map((each) => (
            <Card
              className={cssClasses.eventWrap}
              
            >
              <div className={cssClasses.eventInfo}>
                <div className={cssClasses.eventImg}>
                  <img src={EventDefaultImg} alt="Event" />
                </div>
                <div className={cssClasses.eventData}>
                  <div className={cssClasses.eventName}>{each.launchtitle}</div>
                  <div className={cssClasses.wrapperAddress}>
                    <div className={cssClasses.launchIcon}>
                      <PlaceIcon />
                    </div>
                    <div className={cssClasses.launchLoc}>
                      {each?.addressline1},{each?.addressline2},{each?.city},
                      {each?.state},{each?.country},{each?.pincode}
                    </div>
                  </div>
                  <div className={cssClasses.viewMore}
                 
                    ><img src={ViewMore}
                    style={{cursor:'pointer'}}
                    alt={"More"}
                    onClick={() => {
                        console.log("hoo");
                        navigate("/Home/Dashboard/ViewLaunches/ViewLaunchProject");
                        localStorage.setItem("LauchProject", JSON.stringify(each));
                      }}
                    /></div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
